import _ from 'underscore';

export const responsiveSearchModel = (data) => {
  const ad = data.SuggestedAd;
  const headlines = _.map(ad.Headlines, headline => ({
    Asset: {
      '@odata.type': '#Model.TextAsset',
      AssetType: 'Text',
      Text: headline.Text,
    },
    PinnedField: headline.PinnedFieldTypeString,
    EditorialStatus: 'Approved',
    AssociationType: 'None',
    UiDisplayStatus: 'Inactive',
    IsAlgoGeneratedAsset: headline.IsAlgoGeneratedAsset,
  }));
  const descriptions = _.map(ad.Descriptions, description => ({
    Asset: {
      '@odata.type': '#Model.TextAsset',
      AssetType: 'Text',
      Text: description.Text,
    },
    PinnedField: description.PinnedFieldTypeString,
    EditorialStatus: 'Approved',
    AssociationType: 'None',
    UiDisplayStatus: 'Inactive',
    IsAlgoGeneratedAsset: description.IsAlgoGeneratedAsset,
  }));
  return {
    FinalUrls: [
      ad.FinalUrl,
    ],
    MobileFinalUrls: [
      ad.MobileFinalUrl,
    ],
    Path1: ad.Path1,
    Path2: ad.Path2,
    Headlines: headlines,
    Descriptions: descriptions,
    TrackingUrlTemplate: '',
    NativePreference: 'None',
    FinalUrlSuffix: '',
    UrlCustomParameters: [],
  };
};
